import React, { useState, useEffect } from 'react';
import './buttonsRedesSign.scss'
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { LAWYERS_CONTACTED } from '../../routes';
import { withRouter } from 'react-router-dom';

import { signUpGoogleCreator } from '../../store/actions/UserAction';
/* import { withFirebase } from '../../components/Firebase/index';
 */
// import { fetchingUser, doSignInWithGoogle } from '../../configs/environments/firebase/firebaseApp'

const BtnGoogle = (props) => {

    const [ errorMessageGG, setErrorMessageGG ] = useState(false)
    
    useEffect(() => {
    /* setCurrentUser(onAuthStateChanged);  */
    }, []);

    const signUpGoogle = () => {
        if (
            props.role &&
            (props.role === 'lawFirm' ||
            props.role === 'lawyer')
        ) {
            setErrorMessageGG(true)
        } else {
            props.signUpGoogleCreator()
            .then(res => {
                props.history.push(LAWYERS_CONTACTED);
                
            })
            .catch(err => console.log(err))
        }
    }

    return (
        <>
            <div onClick={signUpGoogle} className='ButtonsRedesSignG gooleColors'>
                <div className='center-container'>
                    <div className='img-container'>
                        <img src="/img/btns/google.svg" alt='google' />
                    </div>
                    <div className='text-container'>
                        <p className='text-btn'>
                            Continuar con Google
                        </p>
                    </div>
                </div>
            </div>
            {errorMessageGG ?
                <p className='ButtonsRedesSignG_errorText'>
                    Ya te encuentras autenticado como {props.role === 'lawyer' ? 'abogado' : 'despacho'}.
                </p> : null
            }
        </>
    );
}

const mapStateToProps = state => ({
    role: state.authClient.role
})

const mapDispatchToProps = dispatch => ({
    signUpGoogleCreator: () => dispatch(signUpGoogleCreator())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BtnGoogle));